import moment from "moment";
import i18n from "../i18n";
import 'moment/locale/de';
import { LangService } from "../services/lang/lang.service";
const langService: LangService = new LangService();

export const tableDate = (date: Date) => {
    const momentDate = moment(new Date(date));
    const week = momentDate.week() + 1;
    const formatedDate = momentDate.format('DD.MM.YYYY');
    const dayName: String = momentDate.format('dddd');
    const formatedDayName = dayName[0].toLocaleUpperCase() + dayName.substr(1, dayName.length);
    const tranlsatedDayName = i18n.t(formatedDayName);
    const outputDay = tranlsatedDayName.substr(0, 2);
    return { week, formatedDate, outputDay }
}

export const formattedTableDateString = (date: Date) => {
    const { week, outputDay, formatedDate } = tableDate(date)
    const weekHeadName = i18n.t('cw');
    return `${weekHeadName} ${week} - ${outputDay}, ${formatedDate}`;
}

export const arrayToString = (tasks: any[]) => {
    const tasksNames = tasks.map(item => item.name);
    return tasksNames.join(', ');
}

export const tableHeightSetter = () => {
    setTimeout(() => {
        try {
            const headerElHeight = document.querySelector('.main-header')?.clientHeight || 0;
            const bodyHeight = document.querySelector('body')?.clientHeight || 0;
            const tableEl: any = document.querySelector('.table-content');
            const height = bodyHeight - (headerElHeight + 70 + 75 + 30 + 75);
            // 560 for 10 rows per page , every row 56 height.
            tableEl.style.minHeight = `${height < 560 ? 560 : height}px`;
        } catch (error) {
            // handle error
        }
    }, 0)
}

const timeDigitCheck = (item: string) => {
    return item.length < 2 ? `0${item}` : item;
}

export const timeFormat = ({ hours, minutes }: any) => {
    return `${timeDigitCheck(String(hours || 0))}:${timeDigitCheck(String(minutes || 0))}`
}

export const addLeadingZero = (value : number = 0) => {
    return value.toString().length === 1 ? `0${value}` : value;
}

export const timeConvert = (num: number) => {
    const hours = (num / 60);
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return {rhours, rminutes};
}

export const formatDate = (date: Date, format: string) => {
    const momentDate = moment(new Date(date));
    const lang = langService.getCurrentLang();
    const formatedDate = momentDate.locale(lang).format(format);
    return formatedDate;
}